import { get } from "../../utils/objectHelpers";

<if(input)>
    <div class="str-shop-header">
        <div class="str-shop-header__left">
            <if(input.categoryModule)>
                <div>
                    <str-categories ...input.categoryModule />
                </div>
            </if>
        </div>
        <div class="str-shop-header__right">
            <!-- TODO: Add location menu 
            <label>Shipping to:</label> <ebay-button variant="fake-link">99999</ebay-button> -->
        </div>
    </div>
</if>
